import * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllFilteredProjectsQueryVariables = Types.Exact<{
  searchText?: Types.InputMaybe<Types.Scalars['String']>;
  billingAdmin?: Types.InputMaybe<Types.Scalars['String']>;
  projectManager?: Types.InputMaybe<Types.Scalars['String']>;
  projectSupervisor?: Types.InputMaybe<Types.Scalars['String']>;
  officeCode?: Types.InputMaybe<Types.Scalars['String']>;
  customerNumber?: Types.InputMaybe<Types.Scalars['String']>;
  projectType?: Types.InputMaybe<Types.Scalars['String']>;
  division?: Types.InputMaybe<Types.Scalars['String']>;
  corpLocation?: Types.InputMaybe<Types.Scalars['String']>;
  dateInEqual?: Types.InputMaybe<Types.Scalars['LocalDate']>;
  dateInBefore?: Types.InputMaybe<Types.Scalars['LocalDate']>;
  dateInAfter?: Types.InputMaybe<Types.Scalars['LocalDate']>;
  state?: Types.InputMaybe<Types.Scalars['String']>;
  county?: Types.InputMaybe<Types.Scalars['String']>;
  afeWoPo?: Types.InputMaybe<Types.Scalars['String']>;
  status?: Types.InputMaybe<Types.ProjectSearchStatus>;
  clientContactName?: Types.InputMaybe<Types.Scalars['String']>;
  projectGroupArgs?: Types.InputMaybe<Types.ProjectGroupArgsInput>;
  certifiedPayroll?: Types.InputMaybe<Types.Scalars['Boolean']>;
  sortBy?: Types.InputMaybe<Types.ProjectSortBy>;
}>;


export type AllFilteredProjectsQuery = { __typename?: 'QueryModel', projects?: { __typename?: 'ProjectsQueryModelOld', allFilteredProjects?: Array<{ __typename?: 'Project', name: string, number: number, actualStartDate?: string | null, actualEndDate?: string | null, officeCode: string, clientContactName: string, estimatedStartDate?: string | null, estimatedEndDate?: string | null, governmentFunding: Types.GovernmentFundingType, afe?: string | null, po?: string | null, wo?: string | null, contractNumber?: string | null, requisitioner?: string | null, glCode?: string | null, costCenter?: string | null, budget?: number | null, section?: string | null, township?: string | null, range?: string | null, block?: string | null, survey?: string | null, internalNotes: string, invoiceNotes: string, geographicLocation: string, dateIn: string, status: Types.ProjectStatus, certifiedPayroll: boolean, customer?: { __typename?: 'Customer', name: string, number?: string | null } | null, stats?: { __typename?: 'ProjectStats', chargesAwaitingApproval: number, chargesBilled: number, chargesPendingBilling: number, chargesUnbilled: number, chargesUnreviewed: number, totalPendingHours: number } | null, expenseRateSheets?: Array<{ __typename?: 'ExpenseRateSheetAssignment', effectiveDate: string, rateSheet?: { __typename?: 'ExpenseRateSheet', name: string } | null } | null> | null, taskRateSheets?: Array<{ __typename?: 'TaskRateSheetAssignment', effectiveDate: string, rateSheet?: { __typename?: 'TaskRateSheet', name: string } | null } | null> | null, projectSupervisor?: { __typename?: 'Employee', firstName: string, lastName: string } | null, projectManager?: { __typename?: 'Employee', firstName: string, lastName: string, userPrincipalName: string } | null, billingAdmin?: { __typename?: 'Employee', firstName: string, lastName: string, userPrincipalName: string } | null, corpLocation?: { __typename?: 'CorpLocation', name: string, id: string } | null, division?: { __typename?: 'Division', id: string, name: string } | null, serviceDescription?: { __typename?: 'ServiceDescription', displayName: string, industry: string, description: string, projectType: string, isOverhead: boolean, legacyWorkCode: string } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null, eogAfeType?: { __typename?: 'EogAfeType', gen: string, sub: string, description: string, afeType: string } | null, projectGroup?: { __typename?: 'ProjectGroup', name: string } | null } | null> | null } | null };


export const AllFilteredProjectsDocument = gql`
    query AllFilteredProjects($searchText: String, $billingAdmin: String, $projectManager: String, $projectSupervisor: String, $officeCode: String, $customerNumber: String, $projectType: String, $division: String, $corpLocation: String, $dateInEqual: LocalDate, $dateInBefore: LocalDate, $dateInAfter: LocalDate, $state: String, $county: String, $afeWoPo: String, $status: ProjectSearchStatus, $clientContactName: String, $projectGroupArgs: ProjectGroupArgsInput, $certifiedPayroll: Boolean, $sortBy: ProjectSortBy) {
  projects {
    allFilteredProjects(
      searchText: $searchText
      billingAdmin: $billingAdmin
      projectManager: $projectManager
      projectSupervisor: $projectSupervisor
      officeCode: $officeCode
      customerNumber: $customerNumber
      projectType: $projectType
      division: $division
      corpLocation: $corpLocation
      dateInEqual: $dateInEqual
      dateInBefore: $dateInBefore
      dateInAfter: $dateInAfter
      state: $state
      county: $county
      afeWoPo: $afeWoPo
      status: $status
      clientContactName: $clientContactName
      projectGroupArgs: $projectGroupArgs
      certifiedPayroll: $certifiedPayroll
      sortBy: $sortBy
    ) {
      name
      number
      customer {
        name
        number
      }
      actualStartDate
      actualEndDate
      stats {
        chargesAwaitingApproval
        chargesBilled
        chargesPendingBilling
        chargesUnbilled
        chargesUnreviewed
        totalPendingHours
      }
      expenseRateSheets {
        rateSheet {
          name
        }
        effectiveDate
      }
      taskRateSheets {
        rateSheet {
          name
        }
        effectiveDate
      }
      officeCode
      clientContactName
      projectSupervisor {
        firstName
        lastName
      }
      projectManager {
        firstName
        lastName
        userPrincipalName
      }
      billingAdmin {
        firstName
        lastName
        userPrincipalName
      }
      estimatedStartDate
      estimatedEndDate
      corpLocation {
        name
        id
      }
      division {
        id
        name
      }
      serviceDescription {
        displayName
        industry
        description
        projectType
        isOverhead
        legacyWorkCode
      }
      governmentFunding
      location {
        state
        county
      }
      afe
      eogAfeType {
        gen
        sub
        description
        afeType
      }
      po
      wo
      contractNumber
      requisitioner
      glCode
      costCenter
      budget
      section
      township
      range
      block
      survey
      internalNotes
      invoiceNotes
      geographicLocation
      dateIn
      status
      certifiedPayroll
      projectGroup {
        name
      }
    }
  }
}
    `;

/**
 * __useAllFilteredProjectsQuery__
 *
 * To run a query within a React component, call `useAllFilteredProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFilteredProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFilteredProjectsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      billingAdmin: // value for 'billingAdmin'
 *      projectManager: // value for 'projectManager'
 *      projectSupervisor: // value for 'projectSupervisor'
 *      officeCode: // value for 'officeCode'
 *      customerNumber: // value for 'customerNumber'
 *      projectType: // value for 'projectType'
 *      division: // value for 'division'
 *      corpLocation: // value for 'corpLocation'
 *      dateInEqual: // value for 'dateInEqual'
 *      dateInBefore: // value for 'dateInBefore'
 *      dateInAfter: // value for 'dateInAfter'
 *      state: // value for 'state'
 *      county: // value for 'county'
 *      afeWoPo: // value for 'afeWoPo'
 *      status: // value for 'status'
 *      clientContactName: // value for 'clientContactName'
 *      projectGroupArgs: // value for 'projectGroupArgs'
 *      certifiedPayroll: // value for 'certifiedPayroll'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useAllFilteredProjectsQuery(baseOptions?: Apollo.QueryHookOptions<AllFilteredProjectsQuery, AllFilteredProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllFilteredProjectsQuery, AllFilteredProjectsQueryVariables>(AllFilteredProjectsDocument, options);
      }
export function useAllFilteredProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllFilteredProjectsQuery, AllFilteredProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllFilteredProjectsQuery, AllFilteredProjectsQueryVariables>(AllFilteredProjectsDocument, options);
        }
export type AllFilteredProjectsQueryHookResult = ReturnType<typeof useAllFilteredProjectsQuery>;
export type AllFilteredProjectsLazyQueryHookResult = ReturnType<typeof useAllFilteredProjectsLazyQuery>;
export type AllFilteredProjectsQueryResult = Apollo.QueryResult<AllFilteredProjectsQuery, AllFilteredProjectsQueryVariables>;